"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsPageLayoutActions = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = require("../../Button");
require("./permissions-page-layout-actions.scss");
const PermissionsPageLayoutActions = (props) => {
    const { className, hidden, onClick } = props;
    if (hidden)
        return null;
    const classNames = (0, classnames_1.default)('permissions-page-layout-actions', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PermissionsPage:save', defaultMessage: 'Save' }), onClick: onClick })));
};
exports.PermissionsPageLayoutActions = PermissionsPageLayoutActions;
//# sourceMappingURL=PermissionsPageLayoutActions.js.map